import React from 'react';
import { MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CommentsCountProps {
  count: number | undefined | null;
  className?: string;
  variant?: 'light' | 'dark';
  isCommentedByCurrentUser?: boolean;
}

const CommentsCount: React.FC<CommentsCountProps> = ({
  count = 0,
  className,
  variant = 'light',
  isCommentedByCurrentUser = false
}) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-foreground';
  const bgColor = variant === 'light' ? 'bg-black/50' : 'bg-muted';

  return (
    <div
      className={cn('flex items-center gap-1 select-none pointer-events-none', className)}
      aria-hidden
    >
      <MessageCircle
        className={cn(
          'w-5 h-5',
          isCommentedByCurrentUser
            ? variant === 'light'
              ? 'fill-white text-white'
              : 'fill-foreground text-foreground'
            : variant === 'light'
              ? 'fill-transparent text-white'
              : 'fill-transparent text-foreground'
        )}
      />
      <span className={cn('text-xs font-semibold px-1 rounded', textColor, bgColor)}>
        {count ?? 0}
      </span>
    </div>
  );
};

export default CommentsCount;
